import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { EIBicRoleModel } from '@models/module/entityInstance';
import { SystemModulesEnum } from '@models/module/main/systemModules.enum';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { CipoStateComponent } from '@shared/components/cipo-state/state.component';
import { UserStore } from '@signal-store/index';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

export type DocumentHeaderData = {
  moduleId: number;
  contractName?: string;
  contractNumber?: string;
  entityInstanceId?: number;
  /* For some reason this is an array, even if it can only have one element (the role set in workflow) - (Laura) */
  ballInCourt?: EIBicRoleModel[];
  preset?: {
    name: string;
    description: string;
  };
  state?: string;
  stateColor?: string;
  stateTextColor?: string;
};

@Component({
  selector: 'cipo-document-header',
  imports: [NgxSkeletonLoaderModule, CipoStateComponent, TranslateModule, FlexLayoutModule],
  templateUrl: './document-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentHeaderComponent {
  private userStore = inject(UserStore);
  data = input<DocumentHeaderData>();

  contractsName = computed(
    () =>
      this.userStore.menuItemsList().find(item => item.moduleId === SystemModulesEnum.Contracts)?.name || 'Contracts',
  );
  currentModule = computed(() => this.userStore.menuItemsList().find(m => m.moduleId === this.data()?.moduleId));
  currentContractName = computed(() => {
    const headerInfo = this.data();
    let contractName = '';
    let contractNo = '';
    if (!headerInfo?.contractName) {
      /* a preset or new document can be open only on the currect contract. In this case - get it from store */
      const contract = this.userStore.contract();
      contractName = contract?.name || '';
      contractNo = contract?.no || '';
    } else {
      contractName = headerInfo.contractName || '';
      contractNo = headerInfo.contractNumber || '';
    }
    return `${contractNo} - ${contractName}`;
  });
  ballInCourtOrgNames = computed(() => {
    const orgNames = (this.data()?.ballInCourt ?? [])
      .map(item => item?.orgName?.trim())
      .filter((orgName): orgName is string => !!orgName);
    return orgNames.length ? Array.from(new Set(orgNames)).join(', ') : '-';
  });
  ballInCourtRoles = computed(() => {
    const roles = (this.data()?.ballInCourt ?? [])
      .map(item => (item?.roleAbbr || item?.roleName)?.trim())
      .filter((role): role is string => !!role);
    return roles.length ? Array.from(new Set(roles)).join(', ') : '-';
  });
}
